import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { LoggerService, REGIONS, StateUtils, tryNormalizeHttpError, UserActions } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomSiteConnector } from '../../connectors/site-context/connectors/custom-site.connector';
import { CustomRegions } from '../actions';

@Injectable()
export class CustomRegionsEffects {
  protected logger = inject(LoggerService);
  loadRegions$: Observable<CustomRegions.CustomRegionsAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomRegions.LOAD_REGIONS),
      map((action: CustomRegions.LoadRegions) => {
        return action.payload;
      }),
      switchMap(({ countryIsoCode, zone }) => {
        return this.siteConnector.getRegionsByZone(countryIsoCode, zone).pipe(
          map(
            (regions) =>
              new CustomRegions.LoadRegionsSuccess({
                entities: regions,
                country: countryIsoCode,
                zone
              })
          ),
          catchError((error) => of(new CustomRegions.LoadRegionsFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  resetRegions$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.CLEAR_USER_MISCS_DATA, CustomRegions.CLEAR_REGIONS),
      map(() => {
        return new StateUtils.LoaderResetAction(REGIONS);
      })
    )
  );

  constructor(private actions$: Actions, private siteConnector: CustomSiteConnector) {}
}
